import IconButton from "@mui/material/IconButton";
import { Icon } from "../Icon/Icon";
import { colors } from "../../styles/colors";
import useStyles from "./styles";
type Props = {
  iconName?: string;
  widthIcon?: string | number;
  heightIcon?: string | number;
  color?: any;
  onClick?: () => void;
  backgroundColor?: string;
  /**
   * Accessible name. This button renders an icon and nothing else, so without
   * it a screen reader announces only "button" -- every action in a table row
   * sounds identical. Optional for backwards compatibility with existing call
   * sites, but it should always be passed.
   */
  ariaLabel?: string;
};

export const CustomIconButton: React.FC<Props> = ({
  iconName,
  heightIcon,
  widthIcon,
  color = colors.WHITE,
  backgroundColor,
  onClick,
  ariaLabel,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.icon}>
      <IconButton
        onClick={onClick}
        /* Falls back to the icon name so the control is never completely
           anonymous, even at a call site that has not been updated yet. */
        aria-label={ariaLabel || iconName}
        style={{
          width: "30px",
          height: "30px",
          backgroundColor: backgroundColor ? backgroundColor : colors.primary,
        }}
      >
        {iconName && (
          <Icon
            name={iconName}
            width={widthIcon}
            height={heightIcon}
            color={color}
          />
        )}
      </IconButton>
    </div>
  );
};
